import React from "react";
import { Star } from "lucide-react";

export function Rating({ value = 0, count, size = 14, showCount = true }) {
  return (
    <div className="flex items-center gap-1" data-testid="rating">
      <Star size={size} className="fill-primary text-primary" strokeWidth={0} />
      <span className="text-sm font-semibold text-stone-800">{value?.toFixed(1)}</span>
      {showCount && count != null && (
        <span className="text-xs text-stone-500">({count.toLocaleString("en-IN")})</span>
      )}
    </div>
  );
}
